(function () {
  'use strict';
  if (window.MatchingBand) { window.MatchingBand.scan(); return; }

  var instances = [];
  var toggleState = {};   // PATCH: remembers ON/OFF per block across AJAX swaps
  var origFetch = window.fetch;

  function handleize(s) {
    return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  function MB(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-mb-data]').textContent);
    this.sw = root.querySelector('[data-mb-switch]');
    this.labelEl = root.querySelector('[data-mb-label]');
    this.priceEl = root.querySelector('[data-mb-price]');
    this.imgEl = root.querySelector('[data-mb-image]');
    this.scope = root.closest('.product-info') || document;
    this.lastValue = null;
    this.current = this.byId(this.data.initialId);

    // PATCH: restore toggle state from before the AJAX swap
    this.key = root.getAttribute('data-mb');
    if (toggleState[this.key] === true) this.sw.setAttribute('aria-checked', 'true');

    var self = this;
    this.sw.addEventListener('click', function () {
      if (self.sw.disabled) return;
      var on = self.sw.getAttribute('aria-checked') === 'true';
      self.sw.setAttribute('aria-checked', on ? 'false' : 'true');
      toggleState[self.key] = !on;   // PATCH
    });
    var kick = function () { setTimeout(function () { self.sync(); }, 60); };
    this.scope.addEventListener('change', kick);
    this.scope.addEventListener('click', kick);
    this.sync();
  }

  MB.prototype.byId = function (id) {
    for (var i = 0; i < this.data.variants.length; i++) {
      if (String(this.data.variants[i].id) === String(id)) return this.data.variants[i];
    }
    return null;
  };

  MB.prototype.getMainValue = function () {
    var els = this.scope.querySelectorAll('[data-option-name="' + handleize(this.data.sync) + '"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var checked = el.querySelector('input:checked');
      if (checked) return checked.value;
      var sel = el.tagName === 'SELECT' ? el : el.querySelector('select');
      if (sel) return sel.value;
    }
    return null;
  };

  MB.prototype.pick = function (value) {
    var idx = this.data.optionIndex;
    if (idx < 0) return this.byId(this.data.initialId);
    var found = null;
    for (var i = 0; i < this.data.variants.length; i++) {
      var v = this.data.variants[i];
      if (norm(v.options[idx]) === norm(value)) {
        if (v.available) return v;
        found = found || v;
      }
    }
    return found;
  };

  MB.prototype.sync = function () {
    var value = this.getMainValue();
    if (value == null || value === this.lastValue) return;
    this.lastValue = value;
    this.apply(this.pick(value), value);
  };

  MB.prototype.apply = function (v, mainValue) {
    this.current = v;
    if (!v) {
      this.labelEl.textContent = this.data.unavailableText + ' ' + mainValue;
      this.priceEl.textContent = '';
      this.sw.setAttribute('aria-checked', 'false');
      this.sw.disabled = true;
      return;
    }
    var idx = this.data.optionIndex;
    this.labelEl.textContent = idx >= 0 ? v.options[idx] : v.title;
    this.priceEl.textContent = v.available ? v.price : this.data.soldOutText;
    if (this.imgEl && v.image) this.imgEl.src = v.image;
    this.sw.disabled = !v.available;
    if (!v.available) this.sw.setAttribute('aria-checked', 'false');
  };

  MB.prototype.isOn = function () {
    return this.root.isConnected && this.current && this.current.available &&
      this.sw.getAttribute('aria-checked') === 'true';
  };

  MB.prototype.mainIds = function () {
    var ids = [];
    [this.root.getAttribute('data-main-input'), this.root.getAttribute('data-sticky-input')].forEach(function (id) {
      var el = id && document.getElementById(id);
      if (el && el.value) ids.push(String(el.value));
    });
    return ids;
  };

  MB.prototype.addToCart = function (qty) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return origFetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: this.current.id, quantity: qty || 1, properties: { '_Matching band': 'true' } }]
      })
    });
  };

  function parseBody(init) {
    var out = { id: null, qty: 1 };
    var body = init && init.body;
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        out.id = body.get('id'); out.qty = parseInt(body.get('quantity'), 10) || 1;
      } else if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body);
          var item = (j.items && j.items[0]) || j;
          out.id = item.id; out.qty = parseInt(item.quantity, 10) || 1;
        } else {
          var p = new URLSearchParams(body);
          out.id = p.get('id'); out.qty = parseInt(p.get('quantity'), 10) || 1;
        }
      }
    } catch (e) {}
    return out;
  }

  // Add the band right after the main product is added successfully
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = origFetch.apply(this, arguments);
    if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return result;

    var req = parseBody(init);
    var target = null;
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (!inst.isOn()) continue;
      if (req.id != null) {
        if (inst.byId(req.id)) continue;                       // this request IS a band
        if (inst.mainIds().indexOf(String(req.id)) === -1) continue; // not the main product
      }
      target = inst; break;
    }
    if (!target) return result;

    return result.then(function (res) {
      if (!res || !res.ok) return res;
      return target.addToCart(req.qty).then(function () {
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        return res;
      }, function () { return res; });
    });
  };

  function scan() {
    instances = instances.filter(function (i) { return i.root.isConnected; });
    document.querySelectorAll('[data-mb]:not([data-mb-ready])').forEach(function (el) {
      el.setAttribute('data-mb-ready', '');
      instances.push(new MB(el));
    });
  }

  window.MatchingBand = { scan: scan };
  scan();

  // Safety net: re-scan on DOM replacement (AJAX section reload) and poll the picker value
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 100); })
    .observe(document.body, { childList: true, subtree: true });
  setInterval(function () { instances.forEach(function (i) { if (i.root.isConnected) i.sync(); }); }, 500);
})();